import MyChartPing from '../CHARTPINS/chartping'
import TotalPing from '../CHARTPINS/TOTALPING'
import { ViewModalHeader } from './ViewModalHeader'
import { useAppSelector } from '../../../../../redux/hooks'




const ViewGrafica = ( props:any ) => {
 


  return (
    
    <>
    {props.id ===null &&
      <div>
      <div
        className='modal fade show d-block'
        id='kt_modal_add_user'
        role='dialog'
        tabIndex={-1}
        aria-modal='true'
      >
        {/* begin::Modal dialog */}
        <div className='modal-dialog modal-dialog-centered mw-950px'>
          {/* begin::Modal content */}
          <div className='modal-content'>
            <ViewModalHeader setID={props.setID} nombre={props.name}/>
            {/* begin::Modal body */}
            <div className='modal-body scroll-y mx-5 mx-xl-15 my-7'>
            <div className='row-xxl-12 ' >

              <MyChartPing chartId={'chartping'+props.chartId} plot={props.categorye} data={props.data}></MyChartPing>
            </div>
            </div>
            {/* end::Modal body */}
          </div>
          {/* end::Modal content */}
        </div>
        {/* end::Modal dialog */}
      </div>
      {/* begin::Modal Backdrop */}
      <div className='modal-backdrop fade show'></div>
      {/* end::Modal Backdrop */}
      </div>
      }


{props.id !== null &&
      <div>
        <div
          className='modal fade show d-block'
          id='kt_modal_add_user'
          role='dialog'
          tabIndex={-1}
          aria-modal='true'
        >
          {/* begin::Modal dialog */}
          <div className='modal-dialog modal-dialog-centered mw-950px'>
            {/* begin::Modal content */}
            <div className='modal-content'>
              <ViewModalHeader setID={props.setID} nombre={props.name}/>
              {/* begin::Modal body */}
              <div className='modal-body scroll-y mx-5 mx-xl-15 my-7'>
              <div className='row-xxl-12 ' >

                <TotalPing chartId={'chartping'+props.chartId} plot={props.categorye} data={props.data}></TotalPing>
              </div>
              </div>
              {/* end::Modal body */}
            </div>
            {/* end::Modal content */}
          </div>
          {/* end::Modal dialog */}
        </div>
        {/* begin::Modal Backdrop */}
        <div className='modal-backdrop fade show'></div>
        {/* end::Modal Backdrop */}
        </div>
      }   
      
    </>
  )
}
export {ViewGrafica}